/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTiposUnidades from 'Infotrack@Modelos/smartStock/tiposUnidades';
import ITiposUnidades from 'Infotrack@Modelos/smartStock/tiposUnidades/entidades/tiposUnidades';

export default class ControladorModeloTiposUnidades {
    private modeloTiposUnidades: ModeloTiposUnidades;
    constructor() {
        this.modeloTiposUnidades = new ModeloTiposUnidades();
    }

    public consultarTiposUnidades() {
        return this.modeloTiposUnidades.consultarTiposUnidades().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTiposUnidades(tiposUnidades: ITiposUnidades) {
        await this.modeloTiposUnidades.crearTiposUnidades(tiposUnidades);
    }

    public async editarTiposUnidades(tiposUnidades: ITiposUnidades) {
        await this.modeloTiposUnidades.editarTiposUnidades(tiposUnidades);
    }
    public async eliminarTiposUnidades(tiposUnidades: ITiposUnidades) {
        await this.modeloTiposUnidades.eliminarTiposUnidades(tiposUnidades);
    }

    public validarEntidad(tiposUnidades: ITiposUnidades): boolean {
        if (tiposUnidades.DescripcionTipoUnidad === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarTiposUnidadesPorFiltro(tiposUnidades: Partial<ITiposUnidades>) {
        return (await this.modeloTiposUnidades.consultarTiposUnidadesPorFiltro(tiposUnidades)).data.Entidades;
    }
}
